import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import router from '@/router';
import statuses from '@/store/statuses';
import dot from 'dot-object';
import clonedeep from 'lodash.clonedeep';
import store from '@/store';
import { VTN } from '@/store/types';

let singleDomain = false;
if (typeof ENV.VUE_APP_API_SAMEDOMAIN === 'undefined') {
  const req = new XMLHttpRequest();
  req.open('HEAD', window.location.origin, false);
  req.setRequestHeader('IsSingleDomain', '1');
  req.send(null);
  singleDomain = req.getResponseHeader('X-SingleDomain');
} else {
  singleDomain = ENV.VUE_APP_API_SAMEDOMAIN === 'true'
    || ENV.VUE_APP_API_SAMEDOMAIN === 'TRUE'
    || ENV.VUE_APP_API_SAMEDOMAIN === true;
}

if (singleDomain) {
  axios.defaults.baseURL = `${window.location.origin}/api/`;
} else {
  axios.defaults.baseURL = location.protocol.includes('https') ? ENV.VUE_APP_API_HTTPS : ENV.VUE_APP_API_HTTP;
}

const Backend = axios.create();

Backend.interceptors.request.use(async (req) => {
  if (req.tokenOverride) req.headers.common['Authorization'] = `Bearer ${req.tokenOverride}`;
  if (req.public) return req;

  if (!req.tokenOverride
    && !req.public
    && !store.getters['Auth/tokenValid'](50)
    && store.getters['Auth/refreshTokenValid'](60)) {
    const token = await store.dispatch(VTN.REFRESH_AUTH_TOKEN);
    req.headers.common['Authorization'] = `Bearer ${token}`;
  }

  return req;
});

Backend.interceptors.response.use((response) => {
  const serverResponse = response.data;

  if (response.headers['content-type'] !== 'application/json') {
    return Promise.resolve({
      data: serverResponse,
      headers: response.headers,
    });
  }
  if (Vue.oflineChck) Vue.oflineChck().setPinged(true);

  switch (response.status) {
    case 200:
      return Promise.resolve({
        data: serverResponse,
        headers: response.headers,
        status: statuses.LOADED,
        when: Date.now()
      });

    case 201:
    case 202:
      return Promise.resolve({
        data: serverResponse,
        headers: response.headers,
        status: statuses.LOADED,
        when: Date.now()
      });

    default:
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject({
        data: serverResponse,
        headers: response.headers,
        status: statuses.ERROR,
        when: Date.now()
      });
  }
}, (error) => {
  let errors = {};
  let message = null;
  if (typeof error.response !== 'undefined') {
    switch (error.response.status) {
      case 401:
        console.log('Unathorized');
        router.replace({ name: 'Login' });
        break;
      case 403:
        console.log('Forbidden error');
        // TODO
        break;
      case 422:
        console.log('Validation error');
        if (error.response.data) {
          errors = clonedeep(error.response.data.errors);
          dot.object(errors);
          message = error.response.data.message;
        }
        break;

      default:
        console.log('Error');
      // TODO
    }
  }

  const headers = error.response ? error.response.headers : {};
  // eslint-disable-next-line prefer-promise-reject-errors
  return Promise.reject({
    data: error.response,
    headers: headers,
    status: statuses.ERROR,
    errors: errors,
    message: message,
    when: Date.now()
  });
});

Vue.use(VueAxios, Backend);
export { axios, Backend };
